// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2f822dd7","396":"a9d837e3","455":"537bcaac","977":"c3425159"}[chunkId] + ".chunk.js";
};